import React, { useState } from "react";
import styled from "styled-components";
import SendIcon from "./images/summary-send-icon.svg";
import MessageIcon from "./images/chat-icon.svg";
import { theme } from "@upsolve/ui";

const MessageBox = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #3c5dff;
  background-color: white;
  border-radius: 12px 0 0 12px;
  padding: 16px 24px;
  width: 100%;
  height: 52px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  gap: 16px;
`;

const Input = styled.input`
  flex-grow: 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: black;

  &::placeholder {
    color: #3c5dff;
    opacity: 0.5;
  }
`;

const SendButton = styled.button`
  height: 52px;
  width: 56px;
  background-color: ${theme.colors.brand[500]};
  color: ${theme.colors.white[900]};
  border: none;
  cursor: pointer;
  border-radius: 0 12px 12px 0;
`;
const SendMessageIconWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const MessageBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.15);
`;

const MessageInputBox = (props: { handleSendMessage: (message: string) => void }) => {
  const [message, setMessage] = useState("");
  return (
    <MessageBoxContainer>
      <MessageBox>
        <SendMessageIconWrapper>
          <MessageIcon />
        </SendMessageIconWrapper>
        <Input
          type="text"
          placeholder="Message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && props.handleSendMessage(message)}
        />
      </MessageBox>
      <SendButton onClick={() => props.handleSendMessage(message)}>
        <SendIcon />
      </SendButton>
    </MessageBoxContainer>
  );
};

export default MessageInputBox;
